import { useLayoutEffect } from "react";
import { PropsWithChildren } from "react";

import { useSiteResolution, SiteResolutionContext, decodeSiteResolutionFunc } from "shared/mechanics/site-resolution";

import { HeaderDesktopComponent, HeaderCompactComponent, HeaderProps } from './HeaderComponents';
import { FooterComponent } from './FooterComponent';
import { SiteSection } from '../model';

export interface SiteLayoutComponentProps {
	activeSection: SiteSection;
}

export const SiteLayoutComponent = (props: PropsWithChildren<SiteLayoutComponentProps>) => {
	const siteResolution = useSiteResolution();

	const headerProps: HeaderProps = { activeSection: props.activeSection };
	const headerComponent = decodeSiteResolutionFunc(
		siteResolution,
		() => <HeaderDesktopComponent {...headerProps} />,
		() => <HeaderCompactComponent {...headerProps} />);

	useLayoutEffect(() => {
		document.documentElement.classList.remove('compact', 'desktop');
		document.documentElement.classList.add(siteResolution.toLocaleLowerCase());
	}, [siteResolution]);

	return (
		<SiteResolutionContext.Provider value={siteResolution}>
			<div className="sl_viewport">
				<div className="header">
					{headerComponent}
				</div>
				<div className='body'>
					{props.children}
				</div>
				<div className='footer'>
					<FooterComponent />
				</div>
			</div>
		</SiteResolutionContext.Provider>
	);
}